import script from "./Autocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./Autocomplete.vue?vue&type=script&setup=true&lang=js"

import "./Autocomplete.vue?vue&type=style&index=0&id=a3db1a62&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3db1a62"]])

export default __exports__